import { User } from "../user/User"

export class OrderBuildStepDetails {
  id: number
  processName: string
  processState: number
  processStatus: number
  completedDate?: string
  completedByUser?: User

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(id: number, processName: string, processState: number, processStatus: number, completedDate?: string, completedByUserJson?: any) {
    this.id = id
    this.processName = processName
    this.processState = processState
    this.processStatus = processStatus
    this.completedDate = completedDate
    this.completedByUser = completedByUserJson ? new User(completedByUserJson) : undefined
  }
}